import React, { CSSProperties } from 'react'

interface BadgeProps {
  color: string
  label: string
  size?: 'sm' | 'md'
  style?: CSSProperties
}

function hexToRgba(hex: string, alpha: number): string {
  const cleaned = hex.replace('#', '')
  const r = parseInt(cleaned.substring(0, 2), 16)
  const g = parseInt(cleaned.substring(2, 4), 16)
  const b = parseInt(cleaned.substring(4, 6), 16)
  if (isNaN(r) || isNaN(g) || isNaN(b)) return `rgba(100,100,100,${alpha})`
  return `rgba(${r},${g},${b},${alpha})`
}

export const Badge: React.FC<BadgeProps> = ({ color, label, size = 'md', style }) => {
  const isSmall = size === 'sm'
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '5px',
        padding: isSmall ? '2px 6px' : '3px 8px',
        borderRadius: '4px',
        fontSize: isSmall ? '11px' : '12px',
        fontWeight: 500,
        background: hexToRgba(color, 0.12),
        color: color,
        border: `1px solid ${hexToRgba(color, 0.25)}`,
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      <span
        style={{
          width: isSmall ? '6px' : '7px',
          height: isSmall ? '6px' : '7px',
          borderRadius: '50%',
          background: color,
          flexShrink: 0,
        }}
      />
      {label}
    </span>
  )
}
